

import { useState } from 'react'
import { unmountComponentAtNode } from 'react-dom'

import {createRoot} from "react-dom/client";

import './index.css';


let domContainer: HTMLDivElement | undefined

function getContainer() {
    if (domContainer == null) {
      domContainer = document.createElement('div')
      domContainer.setAttribute('message-container', '')
      document.body.appendChild(domContainer)
    }
    return domContainer as HTMLDivElement
}


let show: (text: string) => void;


const MessageC = () => {

    const [visible, setVisible] = useState(false)
    const [text, setText] = useState('')

    show = (text: string) => {
        setText(text)
        setVisible(true)

        setTimeout(() => {
            setVisible(false)
        }, 1500)
    }

    return (
        <>
            {visible && <div className='cxin-message-container'> {text} </div>}
        </>
    )
}


class Message {
    constructor() {
      createRoot(getContainer()).render(<MessageC />)
    }

    info(text: string) {
        show(text)
    }

    destroy() {
        unmountComponentAtNode(getContainer())
    }
}

export default new Message();
